<template>
  <scroll-center-dialog v-model="opened" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-card-text>
      <v-text-field :error="hasError('name')"
                    :error-messages="getError('name')"
                    label="Название события"
                    outlined
                    v-model="value.name"
      ></v-text-field>
      <v-textarea v-model="value.description"
                  :error="hasError('description')"
                  :error-messages="getError('description')"
                  outlined
                  label="	Описание мероприятия"
      ></v-textarea>
      <v-datetime-picker
          label="Время и дата начала записи"
          v-model="value.date_opened"
          :dateFormat="'dd.MM.yyyy'"
          locale='ru-ru'
          :textFieldProps="{
                           error:hasError('date_opened'),
                           errorMessages:getError('date_opened'),
                           outlined:true}"
          clearText='Очистить'
          outlined
          okText='Принять'
      ></v-datetime-picker>
      <v-datetime-picker :error="hasError('date_closed')"
                         :error-messages="getError('date_closed')"
                         label="Время и дата конца записи"
                         v-model="value.date_closed"
                         :dateFormat="'dd.MM.yyyy'"
                         :textFieldProps="{
                           error:hasError('date_closed'),
                           errorMessages:getError('date_closed'),
                           outlined:true}"
                         locale='ru-ru'
                         outlined
                         clearText='Очистить'
                         okText='Принять'
      ></v-datetime-picker>
      <v-text-field :error="hasError('start_date')"
                    :error-messages="getError('start_date')"
                    label="Дата начала мероприятия"
                    outlined
                    v-model="value.start_date"
                    type="date"
      ></v-text-field>
      <v-text-field :error="hasError('end_date')"
                    :error-messages="getError('end_date')"
                    label="Дата конца мероприятия"
                    v-model="value.end_date"
                    outlined
                    type="date"
      ></v-text-field>
      <v-checkbox :error="hasError('full_day')"
                  :error-messages="getError('full_day')"
                  label="Полный день"
                  outlined
                  v-model="value.full_day"
      ></v-checkbox>
      <v-text-field :error="hasError('interval')"
                    :error-messages="getError('interval')"
                    label="Временной интервал в минутах"
                    outlined
                    v-model="value.interval"
                    type="number"
      ></v-text-field>
      <v-text-field :error="hasError('max_at_interval')"
                    :error-messages="getError('max_at_interval')"
                    label="Максимальное количество посетителей на интервал"
                    v-model="value.max_at_interval"
                    outlined
                    type="number"
      ></v-text-field>
      <v-select :error="hasError('for_who')"
                :error-messages="getError('for_who')"
                outlined
                v-show="false"
                label="Для кого"
                v-model="value.for_who"
                :items="[
                              {text:'Студенты',value:'student'},
                              {text:'Сотрудники',value:'employee'},
                              {text:'Все',value:'all_auth'}
                              ]"
      ></v-select>
      <v-checkbox :error="hasError('day_at_day')"
                  :error-messages="getError('day_at_day')"
                  label="Запись день в день"
                  v-model="value.day_at_day"
      ></v-checkbox>
      <v-checkbox :error="hasError('repeated')"
                  :error-messages="getError('repeated')"
                  label="Возможность записаться повторно"
                  v-model="value.repeated"
      ></v-checkbox>
      <v-text-field :error="hasError('max_repeat')"
                    :error-messages="getError('max_repeat')"
                    label="Максимальное число повторных записей"
                    v-model="value.max_repeat"
                    outlined
                    type="number"
      ></v-text-field>
      <v-checkbox :error="hasError('closed')"
                  :error-messages="getError('closed')"
                  label="Закрыто мероприятие"
                  v-show="false"
                  v-model="value.closed"
      ></v-checkbox>
      <v-alert type="error" v-if="hasError('non_field_errors')">
        {{ getError('non_field_errors') }}
      </v-alert>
      <v-alert type="error" v-if="hasError('detail')">
        {{ getError('detail') }}
      </v-alert>
      <v-alert type="error" v-if="hasError('error')">
        {{ getError('error') }}
      </v-alert>
    </v-card-text>
  </scroll-center-dialog>
</template>

<script>
import urls from '@/urls/helper.js'
import {loadData, makeGetRequest, makePostRequest} from "@/helper/requests";
import {generateListUidToName} from "@/helper/uidToName";
import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/templates/LoadingAutocomplete.vue";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog.vue";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import {mapActions} from "vuex";

export default {
  name: "Role",
  mixins: [FormErrorsMixin],
  components: {LoadingAutocomplete, ScrollCenterDialog},
  props: {
    opened: Boolean,
    edit: Boolean,
    docs_data: Object,
    user: Object,
    event: Number,
  },
  data() {
    return {
      value: {
        id: undefined,
        name: this.name || undefined,
        date_opened: new Date(),
        date_closed: new Date(),
        start_date: this.start_date || '',
        end_date: this.end_date || '',
        full_day: this.full_day || false,
        interval: this.interval || 30,
        max_at_interval: this.max_at_interval || 1,
        for_who: this.for_who || 'all_auth',
        day_at_day: this.day_at_day || true,
        repeated: this.repeated || false,
        max_repeat: this.max_repeat || 0,
        closed: this.closed || false,
        description: this.description || null,
      },
      selectors: {
        event: [],
      },
    }
  },
  computed: {
    form_title() {
      return this.value.id ? 'Редактировать' : 'Добавить'
    },
  },
  methods: {
    ...mapActions({
      createData: 'events/createEvents',
      changeData: 'events/changeEvents',
      detailData: 'events/loadEventsDetail'
    }),
    save() {
      if (this.value.id) {
        this.changeData({
          id: this.value.id,
          data: this.value,
          finalizer: (val) => {
            this.$emit('close', val)
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      } else {
        this.createData({
          data: this.value,
          finalizer: (val) => {
            this.$emit('close', val)
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
    },
    close() {
      this.$emit('close', false)
    },

    loadSelector() {
      let url = urls.getRecordingUrlWithParameters('admin|events-list', 'list')
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.selectors.event = json.results
      })
    },
  },
  created() {
    // this.loaders.responsible.handler();
    this.loadSelector();
    if (this.docs_data) {
      this.detailData({
        id: this.docs_data.id,
        finalizer: (val) => {
          let data = JSON.parse(JSON.stringify(val))
          data.date_opened = new Date(data.date_opened)
          data.date_closed = new Date(data.date_closed)
          this.value = data
        },
        catcher: (val) => {
          this.mapErrors(val)
        },
      })
    }
  }
}
</script>

<style scoped>
</style>
